import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M7 10l5-5v10z'],
  height: 20,
  width: 20,
});
